var React = require('react');

function Quote (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M0 32v-9.205c0-2.677.509-5.436 1.527-8.278a37.006 37.006 0 0 1 4.03-8.03C7.227 3.932 9.06 1.77 11.053 0l8.184 4.819a49.349 49.349 0 0 0-3.787 7.969c-1.058 2.841-1.587 6.177-1.587 10.007V32H0Zm20.763 0v-9.205c0-2.677.51-5.436 1.527-8.278a37.006 37.006 0 0 1 4.03-8.03C27.99 3.932 29.823 1.77 31.818 0L40 4.819a49.358 49.358 0 0 0-3.786 7.969c-1.059 2.841-1.588 6.177-1.588 10.007V32H20.763Z","fill":"#D32128"}));
}

Quote.defaultProps = {"width":"40","height":"32","fill":"none"};

module.exports = Quote;

Quote.default = Quote;
